import { render, staticRenderFns } from "./CommissionBalances.vue?vue&type=template&id=314a17f8&scoped=true&"
import script from "./CommissionBalances.vue?vue&type=script&lang=js&"
export * from "./CommissionBalances.vue?vue&type=script&lang=js&"
import style0 from "./CommissionBalances.vue?vue&type=style&index=0&id=314a17f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a17f8",
  null
  
)

export default component.exports